import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_timer = _resolveComponent("timer")!

  return (_ctx.activeDate)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(`countdown ${
      _ctx.isReset
        ? 'is-reset text-black'
        : _ctx.activeDate === _ctx.dates.start
        ? 'text-green'
        : _ctx.timeLeftInMs < 86400000 && _ctx.activeDate === _ctx.dates.end
        ? 'text-red'
        : 'text-white'
    }`)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass({ label: !_ctx.isReset })
        }, _toDisplayString(_ctx.isReset
          ? ""
          : _ctx.timeLeftInMs < 0 && _ctx.activeDate === _ctx.dates.start
          ? "Started"
          : _ctx.activeDate === _ctx.dates.start
          ? "Starting in"
          : _ctx.activeDate === _ctx.dates.end
          ? "Ending in"
          : "?"), 3),
        _createVNode(_component_timer, {
          "is-start": _ctx.activeDate === _ctx.dates.start,
          "is-reset": _ctx.isReset,
          date: _ctx.activeDate
        }, null, 8, ["is-start", "is-reset", "date"])
      ], 2))
    : _createCommentVNode("", true)
}